import { useAtom, useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { CtaForm } from '@pairy/sheard/types';
import { AnimatePresence } from 'framer-motion';

import { isPreviewFormSubmittedAtom } from '../../../BulkPdfPreview/index.atom';
import {
  currentPageAtom,
  isCtaModalOpenAtom,
} from '../../../../store/index.atom';

import CtaFormModal from './CtaFormModal';
import FormOpenButton from './FormOpenButton';
import * as Styled from './index.styles';

interface Props {
  ctaForm?: CtaForm;
  isPreview: boolean;
  isEmailVerificationEnabled: boolean;
  isFormSubmitted?: boolean;
  translateKoToEn: (item: string) => string;
  userSubscriptionPlan: string;
}

const CtaFormLayer = ({
  ctaForm,
  isPreview,
  isEmailVerificationEnabled,
  isFormSubmitted,
  translateKoToEn,
  userSubscriptionPlan,
}: Props) => {
  const [isOpenModal, setIsOpenModal] = useAtom(isCtaModalOpenAtom);
  const currentPage = useAtomValue(currentPageAtom);
  const isPreviewFormSubmitted = useAtomValue(isPreviewFormSubmittedAtom);
  const ctaFormPage = ctaForm?.page;
  const blindMode = ctaForm?.blind;

  const isNoneBlindMode = blindMode === 'none';
  const isCtaFormPageAndNoneBlindMode =
    ctaFormPage === currentPage && isNoneBlindMode && !isFormSubmitted;

  useEffect(() => {
    if (isNoneBlindMode) {
      setIsOpenModal(false);
    } else {
      const isOpen = ctaFormPage === currentPage && !isFormSubmitted;

      setIsOpenModal(isOpen);
    }
  }, [isNoneBlindMode, currentPage, ctaFormPage]);

  const closeModal = () => {
    setIsOpenModal(false);
  };

  const openModal = () => {
    setIsOpenModal(true);
  };

  return (
    <AnimatePresence mode="wait">
      {isOpenModal && !isPreviewFormSubmitted && (
        <CtaFormModal
          ctaForm={ctaForm}
          isEmailVerificationEnabled={isEmailVerificationEnabled}
          isPreview={isPreview}
          closeModal={closeModal}
          translateKoToEn={translateKoToEn}
          userSubscriptionPlan={userSubscriptionPlan}
        />
      )}
      {isCtaFormPageAndNoneBlindMode && !isFormSubmitted && (
        <Styled.FlexBottomWrapper direction="column" gap={8}>
          <FormOpenButton
            openModal={openModal}
            buttonText={ctaForm?.name ?? ''}
          />
        </Styled.FlexBottomWrapper>
      )}
    </AnimatePresence>
  );
};

export default CtaFormLayer;
